/*
 * GSI — BazaarVoice widget patches (brand font + accessibility).
 *
 * 1. FONT: BV renders reviews inside an OPEN shadow DOM (styled-components), so
 *    the theme stylesheet can't reach it. Most review text already inherits
 *    Inter, but review titles/headings are set in Oswald, and a stray
 *    "M-Body-Font" token left over from the old theme leaves ~800 elements in a
 *    broken fallback. We inject one <style> into each BV shadow root so
 *    everything renders in the brand face. Re-injects if BV re-renders.
 *    Note: this stops the OFF-brand fonts from showing; it does not stop BV from
 *    downloading Oswald/Kanit/Poppins. The clean source fix is BazaarVoice's own
 *    display-font configuration (set it to Inter and drop the M-Body-Font token).
 *
 * 2. A11Y (WCAG 4.1.2): BV's inline "rating_summary" renders a <button> whose
 *    only content is decorative star SVGs (aria-hidden) — so the control has no
 *    accessible name and SortSite flags it Level A on every product page. It is
 *    also disabled + tabindex="-1". We give it an accurate accessible name from
 *    the Product JSON-LD aggregateRating the theme already emits (falling back to
 *    "no reviews yet" when the product has none). The source fix is BV config.
 */
(function () {
  var CSS = '*{font-family:var(--gsi-brand-font,"Inter"),system-ui,-apple-system,sans-serif !important}';
  var watched = new WeakSet();

  function inject(shadow) {
    if (!shadow.getElementById('gsi-bv-font')) {
      var style = document.createElement('style');
      style.id = 'gsi-bv-font';
      style.textContent = CSS;
      shadow.appendChild(style);
    }
  }

  // Read aggregateRating from the page's Product JSON-LD (once, memoised).
  var ratingCache;
  function productRating() {
    if (ratingCache !== undefined) return ratingCache;
    ratingCache = null;
    var blocks = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < blocks.length; i++) {
      try {
        var data = JSON.parse(blocks[i].textContent);
        var nodes = Array.isArray(data) ? data : [data];
        for (var j = 0; j < nodes.length; j++) {
          var ar = nodes[j] && nodes[j].aggregateRating;
          if (ar && ar.ratingValue) {
            ratingCache = { value: ar.ratingValue, count: ar.reviewCount || ar.ratingCount };
            return ratingCache;
          }
        }
      } catch (e) { /* skip malformed block */ }
    }
    return ratingCache;
  }

  // WCAG 4.1.2 — name the BV inline star-summary button.
  function labelRatingButton() {
    var btns = document.querySelectorAll('.bv_main_rating_button');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.getAttribute('aria-label') || btn.textContent.trim()) continue;
      var r = productRating();
      if (r) {
        var reviews = r.count ? ', ' + r.count + (r.count == 1 ? ' review' : ' reviews') : '';
        btn.setAttribute('aria-label', 'Rated ' + r.value + ' out of 5 stars' + reviews);
      } else {
        btn.setAttribute('aria-label', 'No customer reviews yet');
      }
    }
  }

  function scan() {
    var hosts = document.querySelectorAll('[data-bv-show]');
    for (var i = 0; i < hosts.length; i++) {
      var shadow = hosts[i].shadowRoot;
      if (!shadow) continue;
      inject(shadow);
      if (!watched.has(shadow)) {
        watched.add(shadow);
        // re-inject if BV wipes/replaces the shadow content
        new MutationObserver(function (m) { inject(m[0].target); }).observe(shadow, { childList: true });
      }
    }
    labelRatingButton();
  }

  scan();
  // catch BV's async mount (it appends the widget after page load)
  new MutationObserver(scan).observe(document.documentElement, { subtree: true, childList: true });
  // bounded fallback poll for the first ~30s in case the observer misses the mount
  var tries = 0;
  var iv = setInterval(function () { scan(); if (++tries > 60) clearInterval(iv); }, 500);
})();
